import { createSlice } from '@reduxjs/toolkit';
import { loginAuth } from './authThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';
import { ROLE_PERMISSIONS } from '../../../permissions/permissions';
import { updatePassword } from '../userManagment/userManagementThunk';

const INITIAL_STATE = {
  isLoding: false,
  token: null,
  role:null,
  refresh_token: null,
  isAuthenticated: false,
  user: null,
  status: 'idle',
  error: null,
  permissions:[]
};

const authSlice = createSlice({
  name: 'AUTH_SLICE',
  initialState: INITIAL_STATE,
  reducers: {

     setAuthData: (state, action) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.permissions = action.payload.permissions;
    },

    logout: (state) => {
      return INITIAL_STATE;
    },
    // Standard login success handler
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(loginAuth.pending, (state, action) => {
        state.isLoding = true
        state.status = API_STATUS_TYPE.PENDING
    })
    .addCase(loginAuth.fulfilled, (state, action) => {
        const { accessToken, refreshToken, user } = action.payload.data;

        state.isLoding = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.token = accessToken;
        state.refresh_token = refreshToken;
        state.user = user;
        state.role = user.role
        state.isAuthenticated = true;
        state.permissions = ROLE_PERMISSIONS[user.role] || [];

        localStorage.setItem('auth_token', accessToken);
        localStorage.setItem('refresh_token', refreshToken);
    })

    .addCase(updatePassword.pending, (state, action) => {
        state.isLoding = true;
        state.status = API_STATUS_TYPE.PENDING;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.isLoding = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        // state
      })
        .addCase(updatePassword.rejected, (state, action) => {
        state.isLoding = false;        
        state.error = action.payload.error;
        // state
      })

    .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
            state.isLoding = false
            state.error = action?.payload?.error
        }
    )
  }
});
export const { logout, loginSuccess } = authSlice.actions
export default authSlice.reducer

